export const HOME = '/';

export const SIGNUP = '/signup';
export const LOGIN = '/login';
export const RESET_PASSWORD_REQUEST = '/reset-password';
export const RESET_PASSWORD = '/reset-password/:uid/:token';
export const INSTANCE_ID = '/:instanceId';
export const CREATE = '/create';
export const EDIT = '/edit';
export const VIEW = '/view';
export const BILL_TYPE = '/:billType';
export const PROJECT_LIST = '/projects';
export const SITE_LIST = '/sites';
export const TASK_LIST = '/tasks';
export const DASHBOARD = "/dashboard";
export const CREATE_PROJECT = PROJECT_LIST + CREATE;
export const SITE_DETAILS = SITE_LIST + INSTANCE_ID;
export const CREATE_SITE = SITE_LIST + CREATE;
export const TASK_DETAILS = TASK_LIST + INSTANCE_ID;
export const VIEW_PROJECT = PROJECT_LIST + INSTANCE_ID;

export const USERS_LIST = '/users';
export const PROFILE = '/profile';

export const ANNOUNCEMENT = '/announcement'

export const BILLS_LIST = "/bills";
export const ADD_BILL = "/bills/add/:billType";
export const VIEW_BILL = "/bills/view/:billId";

export const ADVANCE_NOTES_LIST = "/advance-notes";
export const CREATE_ADVANCE_NOTE = ADVANCE_NOTES_LIST + CREATE;
export const VIEW_ADVANCE_NOTE = ADVANCE_NOTES_LIST + VIEW + INSTANCE_ID;
export const EDIT_ADVANCE_NOTE = ADVANCE_NOTES_LIST + EDIT + INSTANCE_ID;

export const USER_LEDGER_LIST = "/user-ledger";
export const PROJECT_LEDGER_LIST = "/project-ledger";

export const DRIVE = '/drive/:type';

export const APPROVALS = '/approvals';
export const ATTENDANCE = "/attendance";
export const CHECK_IN = "/attendance/check-in";
export const CHECK_OUT = "/attendance/check-out";
export const BACK_DATED = "/attendance/backdated";
export const ATTENDANCE_LIST = "/attendance";
export const ATTENDANCE_ADMIN = "/attendance/admin";
export const VIEW_DETAILED_PAGE = "/attendance/view_detailed/:id";

export const TASK_MASTER_LIST = "/task-master";
export const CREATE_TASK_MASTER = TASK_MASTER_LIST + CREATE;

export const WAREHOUSE_MASTER = "/warehouse-master";
export const STOCK = "/stock";

export const VIEW_MATERIAL_REQUESTS = "/material-requests";
export const CREATE_MRR = VIEW_MATERIAL_REQUESTS + CREATE;
export const VIEW_DETAILED_MRR = VIEW_MATERIAL_REQUESTS + INSTANCE_ID;
export const EDIT_MRR = VIEW_MATERIAL_REQUESTS + EDIT + INSTANCE_ID;

export const RETURN_NOTE = "/return-note";
export const ADD_RETURN_NOTE = RETURN_NOTE + CREATE;
export const DETAIL_RETURN_NOTE = RETURN_NOTE +  VIEW + INSTANCE_ID;
export const EDIT_RETURN_NOTE = RETURN_NOTE + EDIT + INSTANCE_ID;

export const DISPATCH_NOTE = "/dispatch-note";
export const CREATE_DISPATCH_NOTE = DISPATCH_NOTE + CREATE;
export const DETAIL_DISPATCH_NOTE = DISPATCH_NOTE + VIEW + INSTANCE_ID;
export const EDIT_DISPATCH_NOTE = DISPATCH_NOTE + EDIT + INSTANCE_ID;

export const PRODUCT_MASTER = "/product-master";
export const CREATE_PRODUCT_MASTER = PRODUCT_MASTER + CREATE;
export const EDIT_PRODUCT_MASTER = PRODUCT_MASTER + EDIT + INSTANCE_ID;

export const GRN_LIST = "/grn";
export const Create_GRN = "/CreateGRN";
export const GRN_Details = "/GRNDetails/:mode/:id";

export const PROCUREMENT_MRR = '/procurement-mrr';
export const CREATE_PMRR = PROCUREMENT_MRR + CREATE;
export const VIEW_DETAILED_PMRR = PROCUREMENT_MRR + VIEW + INSTANCE_ID;
export const EDIT_PMRR = PROCUREMENT_MRR + EDIT + INSTANCE_ID;
export const CREATE_GRN = GRN_LIST + CREATE
export const DETAIL_GRN = GRN_LIST + VIEW + INSTANCE_ID;
export const EDIT_GRN = GRN_LIST + EDIT + INSTANCE_ID;

export const PROCUREMENT_GRN = "/procurement-grn";
export const CREATE_PGRN = PROCUREMENT_GRN + CREATE;
export const VIEW_DETAILED_PGRN = PROCUREMENT_GRN + VIEW + INSTANCE_ID;
export const EDIT_PGRN = PROCUREMENT_GRN + EDIT + INSTANCE_ID;

export const VENDOR_MASTER = "/vendor-master";
export const CREATE_VENDOR = VENDOR_MASTER + CREATE;
export const DETAIL_VENDOR = VENDOR_MASTER + VIEW + INSTANCE_ID;
export const EDIT_VENDOR = VENDOR_MASTER + EDIT + INSTANCE_ID;

export const CLIENT_MASTER = "/client-master";
export const CREATE_CLIENT = CLIENT_MASTER + CREATE;
export const DETAIL_CLIENT = CLIENT_MASTER + VIEW + INSTANCE_ID;
export const EDIT_CLIENT = CLIENT_MASTER + EDIT + INSTANCE_ID;

//TODO: rename these below urls to vendorNote
export const VENDOR_LIST = "/vendors-note";
export const CREATE_VENDOR_GN = VENDOR_LIST + CREATE;
export const VIEW_VENDOR_GN = VENDOR_LIST + VIEW + INSTANCE_ID;
export const EDIT_VENDOR_GN = VENDOR_LIST + EDIT + INSTANCE_ID;

export const SAN_LIST = "/stock-adjustment-note";
export const CREATE_SAN = SAN_LIST + CREATE;
export const VIEW_DETAILED_SAN = SAN_LIST + VIEW + INSTANCE_ID;
export const EDIT_SAN = SAN_LIST + EDIT + INSTANCE_ID;

export const PRODUCT_META_MASTER = "/product-meta-master";
export const STOCK_TRANSACTION_LEDGER = "/stock-transaction-ledger";
